var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Congrats = function Congrats(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.876 20.628c-1.608.603-3.178-.967-2.575-2.575l2.924-7.8a2 2 0 0 1 3.287-.711l4.875 4.875a2 2 0 0 1-.712 3.286l-7.8 2.925Zm-.703-1.872 7.8-2.925-4.875-4.875-2.925 7.8ZM6 2.25a.75.75 0 0 1 .75.75v2a.75.75 0 1 1-1.5 0V3A.75.75 0 0 1 6 2.25ZM20 2.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM20 16.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.75 4a.75.75 0 0 1-.75.75H5a.75.75 0 1 1 0-1.5h2a.75.75 0 0 1 .75.75ZM21.75 4a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75ZM21.75 18a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75ZM16.53 7.47a.75.75 0 0 1 0 1.06l-1.414 1.415a.75.75 0 1 1-1.06-1.061L15.47 7.47a.75.75 0 0 1 1.06 0ZM12.156 2.266a.75.75 0 0 1 .578.89L12.11 6.09a.75.75 0 0 1-1.467-.311l.623-2.935a.75.75 0 0 1 .89-.578ZM21.713 11.768a.75.75 0 0 1-.481.945l-1.902.618a.75.75 0 0 1-.464-1.426l1.902-.618a.75.75 0 0 1 .945.481Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Congrats;